<template>
  <base-dialog
    :visible.sync="visible"
    :show-close="true"
    width="740px"
    class="dialog-wrap"
    border-radius="none"
  >
    <template v-slot:header>
      <div class="header-wrap">
        <div class="title">{{ title }}</div>
      </div>
    </template>
    <main>
      <div class="main-wrap">
        <div v-if="!showTable" v-loading="!showTable" class="empty"></div>
        <template v-else>
          <div class="search-wrap">
            <el-input
              v-model="searchText"
              size="small"
              placeholder="搜索附件名称"
              clearable
              @keyup.native.enter="search"
              @clear="search"
            >
              <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input>
            <div>
              <el-button type="text" @click="batchDownload">批量下载</el-button>
              <el-button type="text" @click="showDownLogs">下载记录</el-button>
            </div>
          </div>
          <base-table
            ref="baseTable"
            table-height="100%"
            :tableColumns="tableColumns"
            :tableData="filterFiles"
            :showPagination="false"
            class="file-list-table"
          >
            <template v-slot:table-suffix>
              <el-table-column label="下载记录" min-width="60" align="center">
                <template v-slot="scope">
                  <span>{{ scope.row.downloadTimes }}次</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="60" align="center">
                <template v-slot="scope">
                  <span class="operation">
                    <i
                      v-if="canPreview(scope.row.type)"
                      class="el-icon-view"
                      @click="preview(scope.row)"
                    ></i>
                    <i class="el-icon-download" @click="download(scope.row)"></i>
                  </span>
                </template>
              </el-table-column>
            </template>
          </base-table>
        </template>
      </div>
    </main>
    <file-preview ref="filePreview"></file-preview>
    <down-logs ref="downLogs"></down-logs>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseTable from "@/components/BaseComponents/Table"
import FilePreview from "@/components/BaseComponents/FilePreview"
import { downloadAttachment, getAttachmentHistory } from "@/api/userCenter/file"
import { url_prefix } from "@/utils/uploadFile"
import { getFileType } from "@/utils/common"
import { loadingService } from "@/utils/ui"
import { download } from "@/utils/aliOss"
import { initOssClient } from "@/store/actions"
import {createZipFile, fileWatermark} from "@/api/sheet/sheetData"
import DownLogs from "@/components/Sheet/DetailDialog/DataDetail/FieldItem/DownLogs.vue";

export default {
  name: "file-history",
  components: { DownLogs, BaseDialog, BaseTable, FilePreview },
  props: {
  },
  data() {
    const tableColumns = [
      {
        label: "文件名称",
        value: "name",
        align: "center"
      },
      {
        label: "更新人",
        value: "creator.name",
        align: "center"
      },
      {
        label: "更新时间",
        value: "updateAt",
        align: "center"
      }
    ]
    return {
      tableColumns,
      url_prefix,
      showTable: true,
      fileList: [],
      filterFiles: [],
      searchText: "",
      visible: false,
      title: "历史版本",
      fileId: "",
      watermark: "",
      control:Object
    }
  },
  beforeCreate() {
    initOssClient()
  },
  // watch:{
  //   visibleFile(newVal,oldVal){
  //     if(newVal==true){
  //       watermark.init({ watermark_txt: this.userInfo })
  //     }else{
  //       watermark.init({ watermark_txt: " " })
  //     }
  //   },
  // },
  methods: {
    open({ fileId, filesForShow,watermark,control }) {
      // console.log(fileId, filesForShow,watermark)
      this.watermark=watermark
      if (filesForShow) {
        this.title = "附件"
        this.filterFiles = this.fileList = filesForShow
      } else {
        this.title = "历史版本"
        this.getFileHistory(fileId)
        this.fileId = fileId
      }
      this.searchText = ""
      this.visible = true
      this.control=control
    },
    getFileHistory(fileId) {
      this.showTable = false
      getAttachmentHistory(fileId).then(res => {
        this.showTable = true
        this.fileList = res.sort(function(a, b) {
          return Date.parse(b.updateAt) - Date.parse(a.updateAt)
        })
        this.filterFiles = this.fileList
      })
    },
    getType: getFileType,
    canPreview(type) {
      return this.getType(type) !== null
    },
    preview(file) {
      let fileInfo = {
        url: this.url_prefix + file.path,
        type: this.getType(file.type),
        name: file.name
      }
      this.$refs.filePreview.preview(fileInfo,[],this.watermark)
    },
    search() {
      this.filterFiles = this.fileList.filter(file => file.name.includes(this.searchText))
    },
    download(file) {

      if(this.control.aw){
        fileWatermark(file.id);
        this.$message.success("下载任务已提交，请等待消息通知！")
      }else{
        downloadAttachment(file.id)
        const loadingInstance = loadingService()
        download({ objectName: file.path, downloadName: file.name }).finally(() => {
          loadingInstance.close()
        })
      }
    },
    batchDownload() {
      let attachmentIds = this.fileList?.map(file => file.id)

      let addWaterMark=this.control.aw
      createZipFile(attachmentIds,addWaterMark).then(() =>
        this.$message.success("下载任务已提交，请等待消息通知！")
      )
    },
    showDownLogs() {
      this.$refs.downLogs.open(this.fileId)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-wrap {
  main {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .main-wrap {
    flex: 1 1;
    display: flex;
    overflow: hidden;
    flex-direction: column;
  }
  .search-wrap {
    display: flex;
    justify-content: space-between;
    margin: 0 10px;
    .el-input {
      width: 280px;
      margin: 5px 6px 5px 0;
    }
    ::v-deep {
      .el-input-group__append {
        padding: 0 10px;
      }
    }
  }
  .file-list-table,
  .empty {
    width: 100%;
  }
  .base-table {
    flex: 1 1;
    overflow: hidden;
  }
  .operation {
    i {
      cursor: pointer;
      & + i {
        margin-left: 4px;
      }
      &:hover {
        color: $color-main;
      }
    }
  }
  ::v-deep .el-dialog {
    height: 60%;
    color: $color-font-first;
    .el-table__body-wrapper {
      .ps__rail-x {
        z-index: 10;
      }
    }
    .el-dialog__body {
      position: relative;
      padding: 0 !important;
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      .task-type-table {
        flex: auto;
        overflow: hidden;
      }
    }
  }
}
</style>
